import XLogoSvg from './xlogo.svg';

export default XLogoSvg;
